import { gql } from '@apollo/client';

export const METRICS_STATUS = gql`
  query MetricsStatus($metricsStatusRequest: MetricsStatusRequest!) {
    getMetricsStatus(metricsStatusRequest: $metricsStatusRequest) {
      lastUpdated
      delay {
        startDate
        endDate
      }
    }
  }
`;
